import React, { useRef } from 'react';
import MuiButton from '@material-ui/core/Button';
import { MuiThemeProvider, Typography } from '@material-ui/core';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';
import { lightThemeV2 } from '../../settings/themes/lightThemeV2';
import { HeaderContent } from '../../components/molecules/HeaderContent';
import { BodyContent } from '../../components/molecules/BodyContent';
import { BeneficiaryForm } from '../../components/organims/BeneficiaryForm';
import { useBeneficiaryStyles } from './index.styles';
import { RequiredIcon } from '../../components/atoms/RequiredIcon';
import { useCreateBeneficiary } from '../../queries/queryBeneficiaries';
import { getCurrentUser } from '../../utils/auth';

export const CreateBeneficiaryComponent = ({ clientId, history }) => {
  const { messages: intlMessages } = useIntl();
  const { mutate: createBeneficiary } = useCreateBeneficiary({
    onSuccess: () => {
      history.push(`/beneficiaries`);
    }
  });
  const classes = useBeneficiaryStyles();
  const descriptionSection = (
    <>
      <FormattedMessage id={'beneficiaries.newBeneficiary.sectionDescription'} />
      <RequiredIcon />.
    </>
  );

  const submitRef = useRef();

  const handleSubmit = values => {
    createBeneficiary({ clientId, data: values });
  };

  const handleCancel = () => {
    history.goBack();
  };

  return (
    <MuiThemeProvider theme={lightThemeV2}>
      <HeaderContent title={intlMessages['beneficiaries.newBeneficiary']} subtitle={descriptionSection}>
        <MuiButton
          variant={'contained'}
          onClick={() => {
            submitRef.current();
          }}
        >
          <FormattedMessage id={'beneficiaries.createBeneficiary'} />
        </MuiButton>
        <MuiButton variant={'outlined'} onClick={handleCancel}>
          <FormattedMessage id={'common.cancel'} />
        </MuiButton>
      </HeaderContent>
      <BodyContent>
        <Typography variant={'h6'} className={classes.heading}>
          <FormattedMessage id={'beneficiaries.form.newBeneficiaryTitle'} />
        </Typography>
        <BeneficiaryForm formRef={submitRef} onSubmit={handleSubmit} />
      </BodyContent>
    </MuiThemeProvider>
  );
};

CreateBeneficiaryComponent.propTypes = {
  clientId: PropTypes.number.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
    push: PropTypes.func.isRequired
  }).isRequired
};

const mapStateToProps = state => ({ clientId: getCurrentUser(state).client_id });

export const CreateBeneficiary = connect(mapStateToProps)(CreateBeneficiaryComponent);
